import http from "../../http";

export const overviewTemplateService = {
    getOverviewTemplateService,
    getSpecificTaskDetailsService,
    removeSpecificTaskService,
    updateTaskService,
    duplicateTaskService,
    getPossiblePredecessorsService,
    AddNewTaskService
}


// get project overview template service
function getOverviewTemplateService(payload: any) {
    // console.log("🚀 ~ getProjectOverviewDetailsService ~ payload:", payload)
    // if tab is provided, add it as query parameter, otherwise don't include it
    const tab = payload.tab ? `?tab=${payload.tab}` : '';
    
    return http.get(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}${tab}`,);
}

// get Specific Details Service
function getSpecificTaskDetailsService(payload: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/task/${payload.taskId}`);
}

// remove specific task service
function removeSpecificTaskService(payload: any) {
    return http.delete(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/task/${payload.taskId}`);
}

// update specific task service
function updateTaskService(payload: any) {
    return http.put(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/task/${payload.taskId}`, payload.data);
}

// duplicate task service
function duplicateTaskService(payload: any) {
    return http.post(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/task/${payload.taskId}/duplicate`);
}

// get possible predecessors service
function getPossiblePredecessorsService(payload: any) {
    const tab = payload.tab ? `?tab=${payload.tab}` : '';

    return http.get(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/possible-predecessors${tab}`);
}

// Add new task service
function AddNewTaskService(payload: any) {
    return http.post(`${process.env.REACT_APP_BASE_URL}/overview-template/${payload.templateId}/task`, payload.data);
}